module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n2r7n4n-339f618e584e35d69f4fd64327e4f1e4.svg";